import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { RiskManagementSolutionBGC, RiskManagementSoltionBG } from "../../constant";

export default function RiskManagementLanding() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "50vh", md: "80vh" },
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh", // Use dvh for mobile browsers
          minHeight: "-webkit-fill-available", // Better mobile support
          zIndex: -1,
          overflow: "hidden",
          pointerEvents: "none",
          background: "black",
          "::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          },
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            transform: "scaleX(-1)",
            filter: "brightness(0.8)",
            minHeight: "-webkit-fill-available",
          }}
        >
          <source src={RiskManagementSoltionBG} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          margin: "0 auto",
          alignItems: "center",
        }}
      >
        {/* Title Box */}
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: isMobile ? "100%" : "50%",
            maxWidth: "1200px",
            textAlign: "left",
            py: 4,
            mt: 4,
          }}
        >
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={12} lg={12}>
              <Typography
                variant="h2"
                sx={{
                  background:
                    "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: { xs: "24px", sm: "32px", md: "48px" },
                  fontWeight: 700,
                  mb: 2,
                  textAlign: "center",
                  letterSpacing: isMobile ? "0px" : "-2.4px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {`Stay Ahead with Intelligent Enterprise Risk Management`}
              </Typography>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12}>
              <Typography
                sx={{
                  color: "white",
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: 1.8,
                  textAlign: "center",
                  marginTop: 5,
                }}
              >
                {"Proactively identify, assess and mitigate enterprise risks through connected risk intelligence, real-time monitoring and AI-driven analytics designed for modern organizations. Enable smarter decision-making with centralized risk visibility across operational, financial, compliance, cyber and strategic risk domains — helping enterprises improve resilience, governance and business continuity. Gain real-time insights into emerging risks, control effectiveness, incident trends and enterprise-wide risk exposure through intelligent dashboards and automated risk workflows."}</Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
